import { render, staticRenderFns } from "./AnnualHistoryByGoods.vue?vue&type=template&id=5edda71c&scoped=true"
import script from "./AnnualHistoryByGoods.vue?vue&type=script&lang=js"
export * from "./AnnualHistoryByGoods.vue?vue&type=script&lang=js"
import style0 from "./AnnualHistoryByGoods.vue?vue&type=style&index=0&id=5edda71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edda71c",
  null
  
)

export default component.exports